// extracted by mini-css-extract-plugin
export default {"appContainer":"app_appContainer__ksZRL"};